import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { MFacility } from '../types'

const HotelAmenities = (props) => {
  const amenitiesMapping = {
    '73': {
      label: 'Entertainment',
      icon: 'fas fa-spa'
    },
    '70': {
      label: 'Facilities',
      icon: 'fas fa-concierge-bell'
    },
    '74': {
      label: 'Health',
      icon: 'fas fa-spa'
    },
    '80': {
      label: 'Meals',
      icon: 'fas fa-utensils'
    },
    '90': {
      label: 'Sports',
      icon: 'fas fa-basketball-ball'
    },
  }

  const renderAmenitiesForGroup = (groupId) => {
    let amenities = props.amenities.filter((f) => f.facility_group_code == groupId)
    if (amenities.length == 0) return
    let amenitiesListing = amenities.map((item, i) => {
      return <li key={item.id}>
        {item.description}
        {item.number && <span className="number">{item.number}</span>}
        {item.fee_exists && <em className="fee">*</em>}
      </li>
    })
    return (
      <React.Fragment>
        <h3 className="amenities-title"><i className={amenitiesMapping[groupId].icon}></i> {amenitiesMapping[groupId].label}</h3>
        <ul className="amenities">
          {amenitiesListing}
        </ul>
      </React.Fragment>
    )
  }

  const hasOrIsMissingIcon = ((facilityName) => {
    if (props.amenities.filter((f) => f.description.toLowerCase() == facilityName.toLowerCase()).length > 0) {
      return <i className="fas fa-check"></i>
    } else {
      return <i className="fas fa-times"></i>
    }
  })

  return (
    <div className={`modal amenities ${props.open ? 'show' : 'hide' }`}>
      <div className="overlay"></div>
      <div className="modal_content">
        <h2 className="modal_title">Amenities</h2>

        <div className="row">
          <div className="col-50">
            <h3 className="amenities-title"><i className="fas fa-wifi"></i> Internet Access</h3>
            <ul className="amenities list fa-ul">
              <li><span className="fa-li">{hasOrIsMissingIcon('Wired Internet')}</span>Wired Internet</li>
              <li><span className="fa-li">{hasOrIsMissingIcon('Internet Access')}</span>Internet Access</li>
              <li><span className="fa-li">{hasOrIsMissingIcon('Wi-fi')}</span>Wi-fi</li>
            </ul>
          </div>

          <div className="col-50">
            <h3 className="amenities-title"><i className="fas fa-paw"></i> Animals</h3>
            <ul className="amenities list fa-ul">
              <li><span className="fa-li">{hasOrIsMissingIcon('Small pets allowed (under 5 kg)')}</span>Small pets allowed (under 5 kg)</li>
              <li><span className="fa-li">{hasOrIsMissingIcon('Large pets allowed (over 5 kg)')}</span>Large pets allowed (over 5 kg)</li>
            </ul>
          </div>
        </div>

        {Object.keys(amenitiesMapping).map((groupCode) => renderAmenitiesForGroup(groupCode) )}
        <small className="disclaimer"><em>*</em> Some services shall be paid at the establishment</small>
        <button title="Close" className="close_modal" onClick={props.toggleModal}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  )
}

HotelAmenities.propTypes = {
  amenities: PropTypes.arrayOf(MFacility)
}

export default HotelAmenities
